import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  skyPointHeader: {
    backgroundColor: "#171717",
    height: 65,
    width: "100%",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 200,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0px 16px 0px 31px",
    "& .logo": {
      height: 39,
      width: 128,
      "@media (max-width:768px)": {
        width: 85,
        height: 26,
      },
    },
    "@media (max-width:768px)": {
      padding: "0px 14px 0px 6px",
    },
  },
  drawerTriggerBtn: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    color: "white",
    fontSize: 14,
    fontWeight: 400,
    fontFamily: "Inter",
    "& > svg": {
      color: "white",
    },
    "@media (max-width:768px)": {
      gap: 4,
      fontSize: 12,
    },
  },
  providerSelect: {
    "& .mantine-Select-input": {
      backgroundColor: "#404040",
      border: "1px solid #737373",
      borderRadius: 8,
      minHeight: 40,
      width: 400,
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
      fontSize: "14px",
      fontWeight: 500,
      color: "#A3A3A3",
      fontFamily: "Inter",
    },
  },
  providerSelectDropdown: {
    backgroundColor: "#404040",
    border: "1px solid #737373",
    borderRadius: 8,
  },
  providerSelectDropdownItem: {
    fontFamily: "Inter",
    color: "#FFF",
    fontSize: 14,
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "#E5E5E5",
      color: "#404040",
    },
    "&[data-selected]": {
      backgroundColor: "#FFF",
      color: "#404040",
      "&:hover": {
        backgroundColor: "#FFF",
        color: "#404040",
      },
    },
  },
  menuTarget: {
    height: 32,
    width: 32,
    backgroundColor: "#262626",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default useStyles;